module.exports = __webpack_public_path__ + "static/media/Guqin Qi 2.70dcf9cd.png";